import React,
{
  useEffect,
  useState
} from "react";

import axios from "axios";

const BASE_API =
  process.env.BASE_API_URL ||
  "https://scanmymenu-nm38.onrender.com/api";

export default function OwnerList() {

  const [owners,
    setOwners] =
    useState([]);

  const [loading,
    setLoading] =
    useState(true);

  useEffect(() => {

    fetchOwners();

  }, []);

  /*
  FETCH OWNERS
  */

  const fetchOwners =
    async () => {

    try {

      const res =
        await axios.get(
          `${BASE_API}/admin/owners`
        );

      setOwners(
        res.data
      );

    } catch (error) {

      alert(
        "Failed to fetch owners"
      );

    } finally {

      setLoading(false);

    }

  };

  /*
  DELETE OWNER
  */

  const deleteOwner =
    async (id) => {

    if (
      !window.confirm(
        "Delete owner?"
      )
    )
      return;

    try {

      await axios.delete(
        `${BASE_API}/admin/owners/${id}`
      );

      fetchOwners();

    } catch (error) {

      alert(
        "Delete failed"
      );

    }

  };

  if (loading)
    return <p>Loading owners...</p>;

  return (

    <div style={{ padding: 30 }}>

      <h2>
        Owner List
      </h2>

      <table style={styles.table}>

        <thead>

          <tr>

            <th>Name</th>

            <th>Email</th>

            <th>Role</th>

            <th>Action</th>

          </tr>

        </thead>

        <tbody>

          {owners.map(
            (owner) => (

              <tr key={owner.id}>

                <td>
                  {owner.username}
                </td>

                <td>
                  {owner.email}
                </td>

                <td>
                  {owner.role}
                </td>

                <td>

                  <button
                    style={
                      styles.deleteBtn
                    }
                    onClick={() =>
                      deleteOwner(
                        owner.id
                      )
                    }
                  >
                    Delete
                  </button>

                </td>

              </tr>

            )
          )}

        </tbody>

      </table>

    </div>

  );

}

const styles = {

  table: {
    width: "100%",
    borderCollapse:
      "collapse"
  },

  deleteBtn: {
    padding: "6px",
    background: "red",
    color: "#fff",
    border: "none"
  }

};